import { formatDollar } from 'helpers/formatters';

export const columnDefs = [
    {
        headerName: 'Location Name',
        field: 'locationName',
        cellStyle: { textAlign: 'left' },
    },
    // {
    //     headerName: 'Experience CR/DB',
    //     field: 'experienceCRDB',
    //     type: 'numericColumn',
    //     valueFormatter: ({ value }: any) => value + '%',
    // },
    {
        headerName: 'Base Rated Premium',
        field: 'baseRatedPremium',
        type: 'numericColumn',
        valueFormatter: ({ value }: any) => formatDollar(value, 0),
    },
    {
        headerName: 'Score',
        field: 'ratingScore',
        type: 'numericColumn',
    },
    {
        headerName: 'Score IRPM',
        field: 'scoreIrpm',
        type: 'numericColumn',
    },
    {
        headerName: 'IRPM',
        field: 'irpm',
        type: 'numericColumn',
    },
    {
        headerName: 'Premium',
        field: 'totalPremium',
        type: 'numericColumn',
        valueFormatter: ({ value }: any) => formatDollar(value, 0),
    },
];

export const defaultColDef = {
    resizable: true,
    sortable: false,
    filter: false,
};
